import Button from '@material-ui/core/Button';

import { FC, useState } from 'react';
import { IAllocationClient } from '~/services/api/clientAllocation/types';
import styles from '../ViewClientAllocation.module.scss';

interface IProps {
  clients: IAllocationClient[];
}

const ClientCell: FC<IProps> = ({ clients }) => {
  const [showClientsMore, setShowClientsMore] = useState(false);
  const maxAmountToShow = 3;

  return (
    <>
      {(showClientsMore ? clients : [...clients].splice(0, maxAmountToShow)).map(client => (
        <div key={client.id} className={styles.clientCell}>
          <div className={styles.clientName}>
            {client.firstName} {client.lastName}
          </div>
          <div className={styles.memo}>{client.memo}</div>
        </div>
      ))}
      {clients.length > maxAmountToShow && (
        <Button
          variant="text"
          onClick={() => setShowClientsMore(prevState => !prevState)}
          className={styles.showMoreButton}
          disableRipple
        >
          {`${showClientsMore ? 'Hide' : 'Show'} More`}
        </Button>
      )}
    </>
  );
};

export default ClientCell;
